import React, { useMemo, useState } from 'react';
import { ProductDetailProps } from '@typings/product';
import useAddToBasket from '@hooks/basket/useAddToBasket';
import useProducts from './product/useProducts';

const useProductDetail = (props: ProductDetailProps) => {
  const [quantity, setQuantity] = useState(1);
  const { trigger, isMutating } = useAddToBasket();
  const { products } = useProducts([{ ...props }]);
  const product = products?.[0];

  const photos = useMemo(() => {
    return product.images!;
  }, [product]);

  const photoQuantity = useMemo(() => (photos?.length > 6 ? 6 : (photos?.length ?? 0)), [photos]);

  const addToCart = React.useCallback(
    async (event: any) => {
      event.preventDefault();
      await trigger([products[0]]);
    },
    [products, trigger],
  );

  const updateQuantity = React.useCallback((event: any) => {
    setQuantity(Number(event.target.value));
  }, []);

  return {
    photos,
    photoQuantity,
    isLoading: isMutating,
    addToCart,
    updateQuantity,
    product,
    quantity,
  };
};

export default useProductDetail;
